const categoricalMetrics = ["metric_type_end_call_reason", "metric_type_topics"]

const CATEGORICAL_MANAGERS = [
  "manager_default_categorical",
  "manager_audio_llm_categorical",
  "manager_end_reason",
  "manager_sentimentanalysis",
  "manager_llm_text",
  "manager_match_expected_sim_wrapper",
  "manager_audio_sentiment",
  "manager_custom_audio_sentiment",
]

export const isCategoricalMetric = (metric: {
  metric_manager: string
  metric_name: string
}) => {
  if (CATEGORICAL_MANAGERS.includes(metric.metric_manager)) {
    return true
  }
  return categoricalMetrics.includes(metric.metric_name)
}
